export const getAllEnumOptions = <TType extends any>(enumType: TType) => {
  const looseTypedEnum: any = enumType
  return Object.keys(looseTypedEnum)
    .filter((key) => !isNaN(parseInt(key)))
    .map((key) => ({
      key,
      label: looseTypedEnum[key as any] as string,
      value: key,
    }))
}
